import React, { useMemo } from 'react';

type BreadcrumbSegment = {
  name: string;
  path: string;
  isLast: boolean;
};

type BreadcrumbProps = {
  filePath: string;
  onNavigate?: (path: string) => void;
};

export const Breadcrumb = React.memo(function Breadcrumb({
  filePath,
  onNavigate,
}: BreadcrumbProps) {
  const segments = useMemo<BreadcrumbSegment[]>(() => {
    if (!filePath) return [];

    const parts = filePath.split('/').filter(Boolean);
    const result: BreadcrumbSegment[] = [];

    let currentPath = '';
    parts.forEach((part, index) => {
      currentPath = currentPath ? `${currentPath}/${part}` : part;
      result.push({
        name: part,
        path: currentPath,
        isLast: index === parts.length - 1,
      });
    });

    return result;
  }, [filePath]);

  if (segments.length === 0) return null;

  return (
    <nav className="breadcrumb" aria-label="File path">
      {segments.map((segment, index) => (
        <React.Fragment key={segment.path}>
          {index > 0 && <span className="breadcrumb-separator">/</span>}
          {segment.isLast ? (
            <span className="breadcrumb-item current" title={segment.path}>
              {segment.name}
            </span>
          ) : (
            <button
              className="breadcrumb-item"
              onClick={() => onNavigate?.(segment.path)}
              title={`Go to ${segment.path}`}
            >
              {segment.name}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
});
